<template>
    <a-popover :trigger="['click']" placement="bottomLeft" overlayClassName="popover-channel zero-padding">
        <template #content>
            <div class="channels">
                <ChannelStatusItem
                    v-if="filteredBusinessChannels.length > 0"
                    v-for="(channel, index) in filteredBusinessChannels"
                    :key="channel._id"
                    :channel="channel"
                />
                <ChannelStatusItem
                    v-if="filteredV2Channels.length > 0"
                    v-for="(channel, index) in filteredV2Channels"
                    :key="channel._id"
                    :channel="channel"
                />

                <ChannelStatusItem
                    v-if="filteredV1Channels.length > 0"
                    v-for="(channel, index) in filteredV1Channels"
                    :key="channel._id"
                    :channel="channel"
                />
            </div>
        </template>
        <md-button
            style="min-width: 20px; max-width: 25px"
            :class="{ [getHealthStatus()]: true }"
            class="actionButtonBreadcrumb m-0 wp-btn"
        >
            <WhatsappIcon :color="getColor" class="whatsapp-channel-icon" :specialBackgroundMode="true" />
        </md-button>
    </a-popover>
</template>
<script>
import WhatsappIcon from "../../views/Pages/Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import { mapGetters, mapState } from "vuex";
import ChannelStatusItem from "./ChannelStatusItem.vue";
import { PERMISSION_TYPES } from "../../language/permissionTypes";

export default {
    name: "ChannelStatusWidget",
    components: { ChannelStatusItem, WhatsappIcon },
    data() {
        return {
        };
    },
    computed: {
        ...mapState({
            channelInfos: (state) => state.whatsapp.channelInfo,
        }),
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
            filteredV1Channels: "channel/getVisibleV1Channels",
            filteredV2Channels: "channel/getVisibleV2Channels",
            filteredBusinessChannels: "channel/getVisibleBusinessChannels",
        }),
        PERMISSION_TYPES() {
            return PERMISSION_TYPES;
        },
        getColor() {
            const status = this.getHealthStatus();

            if (status === "not-healthy") {
                return "red";
            } else if (status === "partially-healthy") {
                return "#faa566";
            } else {
                return "green";
            }
        },
    },
    methods: {
        getHealthStatus() {
            const channels = [...this.filteredBusinessChannels, ...this.filteredV1Channels, ...this.filteredV2Channels];
            const channelInfos = this.channelInfos;
            const isExistsAnyOfflineChannel = !![...this.filteredV1Channels, ...this.filteredV2Channels].find(
                (x) => !(channelInfos[x._id] && channelInfos[x._id].status.ready),
            );
            const isAllOffline = false; // todo implement for business channels

            if (isAllOffline) {
                return "not-healthy";
            } else if (isExistsAnyOfflineChannel) {
                return "partially-healthy";
            } else {
                return "healthy";
            }
        },
    },
    mounted() {
    },
};
</script>
<style lang="scss" scoped>
.md-icon-style {
    color: green;
    font-size: 14px !important;
    display: flex !important;
}

.channels {
    display: flex;
    flex-direction: column;
}

.whatsapp-channel-icon {
    width: 16px !important;
    height: 17px !important;
}

.ant-menu-submenu-arrow {
    position: unset !important;
}

.wp-btn {
    &.partially-healthy {
        //pulse border color animation gray to orange
        border: 1px solid #faa566 !important;
        animation: pulse 2s infinite;
    }
}
</style>
<style>
.popover-channel {
    .ant-popover-inner-content {
        padding: 0px !important;
        width: 100% !important;
    }
}
</style>
